export const CHATBOT_IDENTIFIERS = {
  AS_IS: '2',
  ADVISOR_AUTHENTICATION: '3'
} as const;
 
export const CHATBOT_STORAGE_KEY = 'chatId';